// assets/ce-cart.js — adicionar/remover por Ajax e re-renderizar a gaveta do Copenhagen
(function () {
  const SECTIONS = 'cart-drawer,cart-icon-bubble';
  const json = (r) => r.json();
  const post = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(json);
  const emit = (origem, items, cart) => document.dispatchEvent(new CustomEvent('ce:cart:changed', { detail: { origem, items, cart } }));

  const ceCart = {
    get() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(json); },
    render(response) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && response && response.sections && response.sections['cart-drawer'] && response.sections['cart-icon-bubble']) { drawer.renderContents(response); return; }
      if (document.body.classList.contains('body-template-cart') || location.pathname.endsWith('/cart')) location.reload();
    },
    async add(items, origem) {
      const res = await post('/cart/add.js', { items, sections: SECTIONS, sections_url: location.pathname });
      if (res.status) throw new Error(res.description || res.message || 'erro ao adicionar');
      // publish antes de render (como o product-form nativo): o render troca os <cart-items> e descarta os assinantes antigos, evitando que o onCartUpdate sobrescreva a gaveta com o markup da página /cart
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ce-cart', origem });
      this.render(res);
      { const d = document.querySelector('cart-drawer'); if (d) d.classList.remove('is-empty'); }
      emit(origem || 'ce-cart', items, await this.get());
      return res;
    },
    async remove(variantId, origem) {
      const res = await post('/cart/change.js', { id: String(variantId), quantity: 0, sections: SECTIONS, sections_url: location.pathname });
      if (res.status) throw new Error(res.description || res.message || 'erro ao remover');
      // publish antes de render (como o product-form nativo): o render troca os <cart-items> e descarta os assinantes antigos, evitando que o onCartUpdate sobrescreva a gaveta com o markup da página /cart
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ce-cart', origem });
      this.render(res);
      emit(origem || 'ce-cart-remove', [{ id: variantId, quantity: 0 }], await this.get());
      return res;
    },
    // remove pela posição da linha: não confunde com a mesma variante comprada normalmente
    async removeLine(line, origem) {
      const res = await post('/cart/change.js', { line: Number(line), quantity: 0, sections: SECTIONS, sections_url: location.pathname });
      if (res.status) throw new Error(res.description || res.message || 'erro ao remover');
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ce-cart', origem });
      this.render(res);
      emit(origem || 'ce-cart-remove', [{ line: Number(line), quantity: 0 }], await this.get());
      return res;
    },
    // O brinde (R$ 0) nunca entra em sugestão nem em compre junto: só a regra automática o adiciona.
    paid(p) { const v = (p.variants || []).find((x) => x.available) || (p.variants || [])[0]; return !!v && Number(v.price) > 0; },
    recommendations(productId, limit = 2, intent = 'complementary') {
      return fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}&intent=${intent}`).then(json).then((r) => r.products || []);
    },
    money(cents) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  };
  window.ceCart = ceCart;

  // Delegação: qualquer elemento com data-ce-add='[{"id":123,"quantity":1}]' e data-ce-origem
  document.addEventListener('click', (e) => {
    const el = e.target.closest('[data-ce-add]');
    if (!el) return;
    e.preventDefault();
    if (el.getAttribute('aria-busy')) return;
    let items;
    try { items = JSON.parse(el.getAttribute('data-ce-add')); } catch (err) { console.error('ce-cart: data-ce-add inválido', err); return; }
    el.setAttribute('aria-busy', 'true');
    ceCart.add(items, el.getAttribute('data-ce-origem') || 'ce-cart').catch((err) => alert(err.message)).finally(() => el.removeAttribute('aria-busy'));
  });
  document.addEventListener('change', (e) => {
    const cb = e.target.closest('[data-ce-toggle]');
    if (!cb) return;
    const variantId = cb.getAttribute('data-ce-toggle');
    const origem = cb.getAttribute('data-ce-origem') || 'ce-cart';
    cb.disabled = true;
    (cb.checked ? ceCart.add([{ id: Number(variantId), quantity: 1 }], origem) : ceCart.remove(variantId, origem)).catch((err) => { alert(err.message); cb.checked = !cb.checked; }).finally(() => { cb.disabled = false; });
  });

  // Sugestões da sacola: complementares do item mais caro substituem a coleção genérica quando existem
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fillUpsell = async () => {
    const box = document.querySelector('[data-ce-upsell]:not([data-ce-upsell-done])');
    if (!box) return;
    box.dataset.ceUpsellDone = '1';
    const inCart = (box.dataset.ceUpsellInCart || '').split(',').map(Number);
    try {
      const recs = (await ceCart.recommendations(box.dataset.ceUpsellProduct, 6, 'complementary')).filter((p) => p.available && ceCart.paid(p) && !inCart.includes(p.id)).slice(0, 4);
      if (!recs.length) return;
      const list = box.querySelector('[data-ce-upsell-list]');
      if (!list) return;
      list.innerHTML = recs.map((p) => {
        const v = p.variants.find((x) => x.available) || p.variants[0];
        const url = esc(p.url);
        const img = p.featured_image ? `<img class="ce-img-3x4" loading="lazy" src="${esc(p.featured_image)}${p.featured_image.includes('?') ? '&amp;' : '?'}width=160" alt="">` : '';
        const cta = p.variants.length === 1 ? `<button type="button" class="ce-btn--ghost" data-ce-add='[{"id":${Number(v.id)},"quantity":1}]' data-ce-origem="sugestao-sacola">Adicionar</button>` : `<a class="ce-btn--ghost" href="${url}">Escolher tamanho</a>`;
        return `<li class="ce-cart-upsell__item"><a href="${url}">${img}</a><div class="ce-cart-upsell__info"><a class="ce-cart-upsell__title" href="${url}">${esc(p.title)}</a><span class="ce-cart-upsell__price">${ceCart.money(v.price)}</span>${cta}</div></li>`;
      }).join('');
      box.hidden = false;
    } catch (e) { /* mantém a coleção genérica */ }
  };

  // Brinde automático: entra ao cruzar a meta, sai se cair abaixo. Guarda contra loop.
  let brindeBusy = false;
  const brindeRule = async () => {
    const el = document.querySelector('[data-ce-brinde]');
    if (!el || brindeBusy) return;
    const variant = Number(el.dataset.ceBrinde), meta = Number(el.dataset.ceBrindeMeta), ativo = el.dataset.ceBrindeAtivo === 'true', total = Number(el.dataset.ceTotal);
    if (!variant || !meta) return;
    brindeBusy = true;
    try {
      if (total >= meta && !ativo) await ceCart.add([{ id: variant, quantity: 1, properties: { _brinde: 'sim' } }], 'brinde');
      else if (total < meta && ativo) {
        const linha = Number(el.dataset.ceBrindeLinha);
        await (linha > 0 ? ceCart.removeLine(linha, 'brinde-remove') : ceCart.remove(variant, 'brinde-remove'));
      }
    } catch (e) { /* ignora: estoque do brinde */ } finally { brindeBusy = false; }
  };
  document.addEventListener('ce:cart:changed', (e) => {
    if (String(e.detail?.origem || '').startsWith('brinde')) return; // o próprio brinde dispara este evento
    setTimeout(brindeRule, 50);
  });
  // quantidade/remoção pelos controles nativos da gaveta só disparam cartUpdate
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(brindeRule, 300));

  // Linha do brinde: o Liquid informa o índice (properties com _ não são impressas); esconde quantidade e remover
  const markBrinde = () => {
    const linha = document.querySelector('[data-ce-brinde-linha]')?.dataset.ceBrindeLinha;
    if (!linha) return;
    document.querySelectorAll(`#CartDrawer-Item-${linha}, #CartItem-${linha}`).forEach((li) => li.setAttribute('data-brinde', ''));
  };

  // Ponto único de reação às re-renderizações da gaveta/página
  const onDrawerMutation = () => {
    fillUpsell();
    markBrinde();
  };
  let mutationQueued = false;
  new MutationObserver(() => {
    // callback barato: ignora quando não há trabalho pendente e roda no máximo uma vez por quadro
    if (mutationQueued) return;
    const upsellPendente = document.querySelector('[data-ce-upsell]:not([data-ce-upsell-done])');
    const brindePendente = document.querySelector('[data-ce-brinde-linha]:not([data-ce-brinde-linha=""])') && document.querySelector('[data-brinde]') === null;
    if (!upsellPendente && !brindePendente) return;
    mutationQueued = true;
    requestAnimationFrame(() => { mutationQueued = false; onDrawerMutation(); });
  }).observe(document.body, { childList: true, subtree: true });
  onDrawerMutation();
})();
